// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"601":"5e714d66cf040d57","6157":"2c76842fc6423a66"}[chunkId] + ".css";
};